import { useState } from 'react';
import Requests from './Requests';
import Tags from './Tags';

const TABS = [
  { key: 'requests', label: 'Requests' },
  { key: 'tags', label: 'Tags' },
];

export default function Home() {
  const [activeTab, setActiveTab] = useState('requests');

  return (
    <div className="container-fluid py-3 px-3">
      <ul className="nav nav-pills mb-3">
        {TABS.map(tab => (
          <li className="nav-item" key={tab.key}>
            <button
              className={`nav-link ${activeTab === tab.key ? 'active' : ''}`}
              onClick={() => setActiveTab(tab.key)}
            >
              {tab.label}
            </button>
          </li>
        ))}
      </ul>

      {activeTab === 'requests' && <Requests />}
      {activeTab === 'tags' && <Tags />}
    </div>
  );
}
